<script src="alarms.component.ts"></script>
<app-dashboard-box (buttonClick)="resetFilter()"
                   [buttonLabel]="'common.actions.reset-filter' | translateSafe"
                   [title]="'common.title.alarm-administration' | translateSafe"
                   buttonIconName="refresh"
                   class="transparent alarm-filter"
                   icon="filter_alt">
  <div class="alarm-filter-container">
    <!--<app-input-text [formData]="searchConfig"/>-->

    <app-input-select [formData]="severityConfig"/>

    <app-input-select [formData]="alarmTypeConfig"/>

    <app-input-select [formData]="statusConfig"/>
  </div>
</app-dashboard-box>

<app-dashboard-box [title]="'common.fields.alarms' | translateSafe"
                   icon="notification_important">
  <div class="alarm-cards-container">
    <app-info-card [count]="criticalAlarmCount.toString()"
                   [iconClick]="searchCritical"
                   [title]="'common.enum.alarm-severity.critical' | translateSafe"
                   class="dark-red"
                   icon="warning"/>

    <app-info-card [count]="highAlarmCount.toString()"
                   [iconClick]="searchHigh"
                   [title]="'common.enum.alarm-severity.high' | translateSafe"
                   class="red"
                   icon="warning"/>


    <app-info-card [count]="warningAlarmCount.toString()"
                   [iconClick]="searchWarning"
                   [title]="'common.enum.alarm-severity.warning' | translateSafe"
                   class="yellow"
                   icon="warning"/>

    <app-info-card [count]="infoAlarmCount.toString()"
                   [iconClick]="searchInfo"
                   [title]="'common.enum.alarm-severity.info' | translateSafe"
                   class="blue"
                   icon="info"/>
  </div>

  <app-table [loading]="loading"
             [tableConfig]="tableConfig"
             [tableRows]="tableRows"/>
</app-dashboard-box>

@if (isAlarmDetailOpen) {
  <app-dialog-base (outSideClick)="closeAlarmDetailDialog()"
                   [buttonAction]="closeAlarmDetailDialog"
                   [class.open]="isAlarmDetailOpen"
                   [title]="('dialogs.alarm.detail' | translateSafe: {
                  name: (alarmDetailDialogName | translateSafe)
                 })"
                   iconLeft="notification_important">

    <dialog-alarm-detail (closeClick)="closeAlarmDetailDialog()"
                         [alarm]="selectedAlarm"
                         [loading]="alarmStatusLoading"/>
  </app-dialog-base>
}
